/** The "calc" mark a derived figure carries wherever the pipeline shows it,
 *  with its basis (formula, and that no document states it) as the title. */
export function DerivedTag({ basis }: { basis: string | null }) {
  if (!basis) return null
  return (
    <span title={basis} className="ml-0.5 text-[8px] uppercase text-violet-300/80">
      calc
    </span>
  )
}
